// routes
// routes
// import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;
export const MOCK_API = process.env.REACT_APP_MOCK_API || 'http://localhost:4000';
export const CARDS_API = process.env.REACT_APP_CARDS_API || HOST_API;

// Course Module Version (v1 - real API, v2 - mock/reference)
export const COURSE_MODULE_VERSION = process.env.REACT_APP_COURSE_VERSION || 'v1';

export const CURRENT_PROJECT = "notibot";

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;
export const YANDEX_API = {
  clientId: 'ee6d5109dc6f41afb311825f7747209d',
};

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = '/dashboard/shops'; // as '/dashboard'

export const IS_DEV = process.env.NODE_ENV === 'development';

export const NOTIFY_TXT_VARS = [
  'first_name', 'last_name', 'username', 'user_id', 'date', 'time'
];
